import React from 'react';

interface DashboardIconProps {
  className?: string;
}

const DashboardIcon: React.FC<DashboardIconProps> = ({ className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M5 11.75H7C8.24264 11.75 9.25 12.7574 9.25 14V19C9.25 20.2426 8.24264 21.25 7 21.25H5C3.75736 21.25 2.75 20.2426 2.75 19V14C2.75 12.7574 3.75736 11.75 5 11.75ZM14 14.75H19C20.2426 14.75 21.25 15.7574 21.25 17V19C21.25 20.2426 20.2426 21.25 19 21.25H14C12.7574 21.25 11.75 20.2426 11.75 19V17C11.75 15.7574 12.7574 14.75 14 14.75ZM14 2.75H19C20.2426 2.75 21.25 3.75736 21.25 5V10C21.25 11.2426 20.2426 12.25 19 12.25H14C12.7574 12.25 11.75 11.2426 11.75 10V5C11.75 3.75736 12.7574 2.75 14 2.75ZM5 2.75H7C8.24264 2.75 9.25 3.75736 9.25 5V7C9.25 8.24264 8.24264 9.25 7 9.25H5C3.75736 9.25 2.75 8.24264 2.75 7V5C2.75 3.75736 3.75736 2.75 5 2.75Z" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
);

export default DashboardIcon;